import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Modal, Button, Select, Input, Table, Form } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";

interface Props {
  show?: boolean;
  dataMedicine?: (data: any) => void;
  type?: number;
  path?: string;
}

const ModalMedicine: React.FC<Props> = ({
  show,
  dataMedicine,
  type = 1,
  path,
}) => {
  const navigate = useHistory();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [sum, setSum] = useState<any>([]);
  const [medicine, setMedicine] = useState<any>([]);
  const types = [
    { value: "code", label: "Code" },
    { value: "name", label: "Name" },
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: "key",
    },
    {
      title: "Code",
      dataIndex: "code",
      colSpan: 1,
      width: "20%",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      colSpan: 1,
      width: "50%",
      key: "name",
    },

    {
      title: "Unit",
      dataIndex: "unit",
      colSpan: 1,
      width: "10%",
      align: "center" as const,
      key: "unit",
    },
    {
      title: "Price/Unit",
      dataIndex: "price",
      colSpan: 1,
      width: "10%",
      align: "center" as const,
      key: "unit",
    },
    {
      title: "Select",
      ataIndex: "id",
      colSpan: 1,
      width: "10%",
      align: "center" as const,
      key: "Select",
      render: (data: any) => (
        <a onClick={() => addDataMedicine(data)}>
          {console.log("data", data)}
          <Icon
            icon="akar-icons:circle-plus-fill"
            width="1.2rem"
            height="1.2rem"
            style={{ color: "#4D7E7F" }}
          />
        </a>
      ),
    },
  ];

  const getDataMedicine = () => {
    // axios.get(`/treatments?page=1&search=`).then((res) => {
    //   let xData = res?.data?.data;
    //   xData = xData.map((x: any, index1: number) => ({ ...x, quantity: 1 }));
    //   setTreatment(xData);
    // });
    const medicine = [
      {
        code: "MFOC26001",
        name: "Vitamin B-12 (ไทย)",
        price: "1.00",
        unit: "เม็ด",
      },
      { code: "MFOC26002", name: "S-W-I 100 ml", price: "1.00", unit: "ขวด" },
      {
        code: "MFOC26003",
        name: "Vitamin C ไทย 100 ml (1 ขวด = 100 ml )",
        price: "20.00",
        unit: "ml",
      },
      {
        code: "MFOC26004",
        name: "Luthione 600 ml",
        price: "1.00",
        unit: "กล่อง",
      },
      {
        code: "MFOC26005",
        name: "50% Magnum Sulfate inj (1 amp/2ml)",
        price: "1.00",
        unit: "กล่อง",
      },
      {
        code: "MFOC26006",
        name: "BIOMO LIPON 600 mg 20 Ampullen",
        price: "10.00",
        unit: "Amp",
      },
      {
        code: "MFOC26007",
        name: "Pyridoxine Hydrochioride B6 ไทย 100 mg anb inj",
        price: "1.00",
        unit: "กล่อง",
      },
    ];
    setMedicine(medicine);
  };

  const addDataMedicine = (values: any) => {
    // console.log("values =>", values);
    // if (sum.length !== 0) {
    //   const filter = sum?.filter((x: any) => x.id !== values.id);
    //   if (filter.length !== 0) {
    //     setList(values);
    //   }
    // } else {
    //   setList(values);
    // }

    dataMedicine?.(values);
    setIsModalVisible(false);
  };

  useEffect(() => {
    // if (list.length !== 0) {
    //   sum.push(list);
    //   console.log("list =>", list);
    //   console.log("sum =>", sum);
    // }
  }, [list]);

  useEffect(() => {
    getDataMedicine();
  }, []);

  return (
    <div>
      <div className="btn-confirm">
        <Button type="primary" onClick={showModal}>
          เพิ่มรายการ/Add Order
        </Button>
      </div>
      <div>
        <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          className="modal-doctor"
        >
          <h3>เลือกรายการ</h3>
          <div className="input-search">
            <Select
              bordered={false}
              placeholder="Search for Name"
              suffixIcon={
                <Icon
                  icon="ant-design:caret-down-filled"
                  style={{ color: "#AEAEAE" }}
                />
              }
              onChange={(e) => {
                // setDataSearch({ ...dataSearch, typeSearch: e})
                setIsDisable(true);
              }}
              options={types}
            />
            <Input.Search
              bordered={false}
              disabled={isDisable ? false : true}
              onSearch={(e) => {
                // setDataSearch({ ...dataSearch, search: e})
              }}
            />
          </div>

          <div style={{ marginTop: "20px" }} className="table-data">
            <Table
              columns={columns}
              dataSource={medicine}
              scroll={{ x: 100 }}
              pagination={false}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default ModalMedicine;
